import { TAGS } from "../constants";
import { PriorAuthorization } from "../types";
import { api } from "./api";

export const priorAuthorizationsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getPriorAuth: builder.query<PriorAuthorization, number>({
      query: (id) => ({
        method: "GET",
        url: `/api/prior-authorizations/${id}`,
      }),
      providesTags: (_res, _error, args) => [
        { type: TAGS.PRIOR_AUTHORIZATION, id: args },
      ],
    }),
  }),
});

export const { useGetPriorAuthQuery } = priorAuthorizationsApi;
